import React from 'react'
import Modal from './modal'
import Button from './button'

interface UpdateNameModalProps {
  isOpen: boolean
  newName: string | undefined
  onConfirm: () => void
}

const UpdateNameModal = ({ isOpen, newName, onConfirm }: UpdateNameModalProps) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onConfirm}
    width={500}
  >
    <div>
      <h2 className='mt0'>Name update</h2>
      <p>
        This save was renamed to <strong>&lsquo;{newName}&rsquo;</strong> by another user. It will be saved under the updated name.
      </p>
      <div className='flex justify-end mt3'>
        <Button btnType='primary' className='ml2' onClick={onConfirm}>
          OK
        </Button>
      </div>
    </div>
  </Modal>
)

export default UpdateNameModal
